import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AWSDate: { input: any; output: any };
  AWSDateTime: { input: Date; output: Date };
  Long: { input: any; output: any };
};

export type Company = {
  __typename?: "Company";
  company_id?: Maybe<Scalars["ID"]["output"]>;
  company_name?: Maybe<Scalars["String"]["output"]>;
  company_sales_rep?: Maybe<Scalars["String"]["output"]>;
};

export type CompanyPage = {
  __typename?: "CompanyPage";
  companies?: Maybe<Array<Maybe<Company>>>;
  count?: Maybe<Scalars["Int"]["output"]>;
  current_page?: Maybe<Scalars["Int"]["output"]>;
  last_page?: Maybe<Scalars["Int"]["output"]>;
  per_page?: Maybe<Scalars["Int"]["output"]>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type ContactInfo = {
  __typename?: "ContactInfo";
  email?: Maybe<Scalars["String"]["output"]>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  last_name?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export enum FieldType {
  CompanyId = "company_id",
  CompanyName = "company_name",
  CompanySalesRep = "company_sales_rep",
  NetworkManufacturer = "network_manufacturer",
  NetworkModel = "network_model",
  NetworkName = "network_name",
  RxBytes = "rx_bytes",
  TerminalAddress = "terminal_address",
  TerminalAltName = "terminal_alt_name",
  TerminalEquipAntenna = "terminal_equip_antenna",
  TerminalEquipBuc = "terminal_equip_buc",
  TerminalId = "terminal_id",
  TerminalIpaddrManagement = "terminal_ipaddr_management",
  TerminalIpaddrNat = "terminal_ipaddr_nat",
  TerminalIpaddrPrimary = "terminal_ipaddr_primary",
  TerminalLatitude = "terminal_latitude",
  TerminalLongitude = "terminal_longitude",
  TerminalModemSerial = "terminal_modem_serial",
  TerminalModemType = "terminal_modem_type",
  TerminalName = "terminal_name",
  TerminalNotes = "terminal_notes",
  TerminalPhysicalModemLocation = "terminal_physical_modem_location",
  TerminalServicePlan = "terminal_service_plan",
  TerminalServicePlanUsageBased = "terminal_service_plan_usage_based",
  TerminalStatus = "terminal_status",
  TotalBytes = "total_bytes",
  TxBytes = "tx_bytes",
}

export type FilterByField = {
  field?: InputMaybe<FieldType>;
  search_string?: InputMaybe<Scalars["String"]["input"]>;
};

export type Network = {
  __typename?: "Network";
  network_id?: Maybe<Scalars["ID"]["output"]>;
  network_manufacturer?: Maybe<Scalars["String"]["output"]>;
  network_model?: Maybe<Scalars["String"]["output"]>;
  network_name?: Maybe<Scalars["String"]["output"]>;
};

export type Query = {
  __typename?: "Query";
  getCompanies?: Maybe<CompanyPage>;
  getContact?: Maybe<ContactInfo>;
  getTerminalUsage?: Maybe<TermninalUsagePage>;
  getTerminals?: Maybe<TerminalPage>;
};

export type QueryGetCompaniesArgs = {
  company_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetTerminalUsageArgs = {
  frequency?: InputMaybe<Scalars["String"]["input"]>;
  terminal_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  time_end?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  time_start?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
};

export type QueryGetTerminalsArgs = {
  company_id?: InputMaybe<Scalars["Int"]["input"]>;
  date_end?: InputMaybe<Scalars["AWSDate"]["input"]>;
  date_start?: InputMaybe<Scalars["AWSDate"]["input"]>;
  filter?: InputMaybe<QueryFilter>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  terminal_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type QueryFilter = {
  fields?: InputMaybe<Array<InputMaybe<FieldType>>>;
  filter_by_field?: InputMaybe<Array<InputMaybe<FilterByField>>>;
  search_string?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<SortOrder>>>;
};

export type SortOrder = {
  sort_by?: InputMaybe<FieldType>;
  sort_order?: InputMaybe<SortOrderType>;
};

export enum SortOrderType {
  Asc = "ASC",
  Desc = "DESC",
}

/**
 *   enum statusType {
 *      Enabled
 *      Down
 *      Locked
 *      Decommissioned
 *      Pending Activation
 *      Duplicate
 *      Site Survey
 *      Demonstration Only
 *  }
 */
export type Terminal = {
  __typename?: "Terminal";
  company?: Maybe<Company>;
  network?: Maybe<Network>;
  terminal_address?: Maybe<Scalars["String"]["output"]>;
  terminal_alt_name?: Maybe<Scalars["String"]["output"]>;
  terminal_equip_antenna?: Maybe<Scalars["String"]["output"]>;
  terminal_equip_buc?: Maybe<Scalars["String"]["output"]>;
  terminal_id: Scalars["ID"]["output"];
  terminal_ipaddr_management?: Maybe<Scalars["String"]["output"]>;
  terminal_ipaddr_nat?: Maybe<Scalars["String"]["output"]>;
  terminal_ipaddr_primary?: Maybe<Scalars["String"]["output"]>;
  terminal_latitude?: Maybe<Scalars["Float"]["output"]>;
  terminal_longitude?: Maybe<Scalars["Float"]["output"]>;
  terminal_modem_serial?: Maybe<Scalars["String"]["output"]>;
  terminal_modem_type?: Maybe<Scalars["String"]["output"]>;
  terminal_name?: Maybe<Scalars["String"]["output"]>;
  terminal_notes?: Maybe<Scalars["String"]["output"]>;
  terminal_physical_modem_location?: Maybe<Scalars["String"]["output"]>;
  terminal_service_plan?: Maybe<Scalars["String"]["output"]>;
  terminal_service_plan_usage_based?: Maybe<Scalars["String"]["output"]>;
  terminal_status?: Maybe<Scalars["String"]["output"]>;
  usage_summary?: Maybe<UsageSummary>;
};

export type TerminalPage = {
  __typename?: "TerminalPage";
  count?: Maybe<Scalars["Int"]["output"]>;
  current_page?: Maybe<Scalars["Int"]["output"]>;
  date_end?: Maybe<Scalars["AWSDate"]["output"]>;
  date_start?: Maybe<Scalars["AWSDate"]["output"]>;
  last_page?: Maybe<Scalars["Int"]["output"]>;
  per_page?: Maybe<Scalars["Int"]["output"]>;
  terminals?: Maybe<Array<Maybe<Terminal>>>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type TerminalUsage = {
  __typename?: "TerminalUsage";
  terminal?: Maybe<Terminal>;
  usage?: Maybe<Array<Maybe<Usage>>>;
};

/**   Usage return format varies depeinding on the Network */
export type TermninalUsagePage = {
  __typename?: "TermninalUsagePage";
  count?: Maybe<Scalars["Int"]["output"]>;
  current_page?: Maybe<Scalars["Int"]["output"]>;
  last_page?: Maybe<Scalars["Int"]["output"]>;
  per_page?: Maybe<Scalars["Int"]["output"]>;
  terminal_usage?: Maybe<Array<Maybe<TerminalUsage>>>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

// ! ADD NEW TECHNOLOGY
export type Usage =
  | UsageItemNewtec
  | UsageItemPge
  | UsageItemUhp
  | UsageItemViasat
  | UsageItemGroundControl
  | UsageItemKoreWireless
  | UsageItemOneWeb
  | UsageItemCuris
  | UsageItemHammer;

export type UsageItemNewtec = {
  __typename?: "UsageItemNewtec";
  bytes: Scalars["Long"]["output"];
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  timestamp_end: Scalars["AWSDateTime"]["output"];
  timestamp_start: Scalars["AWSDateTime"]["output"];
};

export type UsageItemPge = {
  __typename?: "UsageItemPGE";
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  rx_2?: Maybe<Scalars["Long"]["output"]>;
  rx_3?: Maybe<Scalars["Long"]["output"]>;
  rx_5?: Maybe<Scalars["Long"]["output"]>;
  rx_6?: Maybe<Scalars["Long"]["output"]>;
  rx_high?: Maybe<Scalars["Long"]["output"]>;
  rx_low?: Maybe<Scalars["Long"]["output"]>;
  rx_med?: Maybe<Scalars["Long"]["output"]>;
  rx_total?: Maybe<Scalars["Long"]["output"]>;
  timestamp_end: Scalars["AWSDateTime"]["output"];
  timestamp_start: Scalars["AWSDateTime"]["output"];
  tx_2?: Maybe<Scalars["Long"]["output"]>;
  tx_3?: Maybe<Scalars["Long"]["output"]>;
  tx_5?: Maybe<Scalars["Long"]["output"]>;
  tx_6?: Maybe<Scalars["Long"]["output"]>;
  tx_high?: Maybe<Scalars["Long"]["output"]>;
  tx_low?: Maybe<Scalars["Long"]["output"]>;
  tx_med?: Maybe<Scalars["Long"]["output"]>;
  tx_total?: Maybe<Scalars["Long"]["output"]>;
  usage_total?: Maybe<Scalars["Long"]["output"]>;
};

export type UsageItemUhp = {
  __typename?: "UsageItemUHP";
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  rx_2?: Maybe<Scalars["Long"]["output"]>;
  rx_3?: Maybe<Scalars["Long"]["output"]>;
  rx_5?: Maybe<Scalars["Long"]["output"]>;
  rx_6?: Maybe<Scalars["Long"]["output"]>;
  rx_high?: Maybe<Scalars["Long"]["output"]>;
  rx_low?: Maybe<Scalars["Long"]["output"]>;
  rx_med?: Maybe<Scalars["Long"]["output"]>;
  rx_total?: Maybe<Scalars["Long"]["output"]>;
  timestamp_end: Scalars["AWSDateTime"]["output"];
  timestamp_start: Scalars["AWSDateTime"]["output"];
  tx_2?: Maybe<Scalars["Long"]["output"]>;
  tx_3?: Maybe<Scalars["Long"]["output"]>;
  tx_5?: Maybe<Scalars["Long"]["output"]>;
  tx_6?: Maybe<Scalars["Long"]["output"]>;
  tx_high?: Maybe<Scalars["Long"]["output"]>;
  tx_low?: Maybe<Scalars["Long"]["output"]>;
  tx_med?: Maybe<Scalars["Long"]["output"]>;
  tx_total?: Maybe<Scalars["Long"]["output"]>;
  usage_total?: Maybe<Scalars["Long"]["output"]>;
};

export type UsageItemViasat = {
  __typename?: "UsageItemViasat";
  bytes: Scalars["Long"]["output"];
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  timestamp_end: Scalars["AWSDateTime"]["output"];
  timestamp_start: Scalars["AWSDateTime"]["output"];
};

export type UsageItemGroundControl = {
  __typename?: "UsageItemGroundControl";
  bytes: Scalars["Long"]["output"];
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  timestamp_end: Scalars["AWSDateTime"]["output"];
  timestamp_start: Scalars["AWSDateTime"]["output"];
};

export type UsageItemKoreWireless = {
  __typename?: "UsageItemKoreWireless";
  bytes: Scalars["Long"]["output"];
  enabled?: Maybe<Scalars["String"]["output"]>;
  timestamp_end: Scalars["AWSDateTime"]["output"];
  timestamp_start: Scalars["AWSDateTime"]["output"];
};

// ! ADD NEW TECHNOLOGY
export type UsageItemOneWeb = {
  __typename?: "UsageItemOneWeb";
  tx: Scalars["Long"]["output"];
  rx: Scalars["Long"]["output"];
  enabled?: Maybe<Scalars["String"]["output"]>;
  timestamp_end: Scalars["AWSDateTime"]["output"];
  timestamp_start: Scalars["AWSDateTime"]["output"];
};

export type UsageItemCuris = {
  __typename?: "UsageItemCuris";
  tx: Scalars["Long"]["output"];
  rx: Scalars["Long"]["output"];
  enabled?: Maybe<Scalars["String"]["output"]>;
  timestamp_end: Scalars["AWSDateTime"]["output"];
  timestamp_start: Scalars["AWSDateTime"]["output"];
}

export type UsageItemHammer = {
  __typename?: "UsageItemHammer";
  tx: Scalars["Long"]["output"];
  rx: Scalars["Long"]["output"];
  enabled?: Maybe<Scalars["String"]["output"]>;
  timestamp_end: Scalars["AWSDateTime"]["output"];
  timestamp_start: Scalars["AWSDateTime"]["output"];
}

export type UsageSummary = {
  __typename?: "UsageSummary";
  rx_bytes?: Maybe<Scalars["Long"]["output"]>;
  total_bytes?: Maybe<Scalars["Long"]["output"]>;
  tx_bytes?: Maybe<Scalars["Long"]["output"]>;
};

export type User = {
  __typename?: "User";
  company?: Maybe<Company>;
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name_first?: Maybe<Scalars["String"]["output"]>;
  name_last?: Maybe<Scalars["String"]["output"]>;
};

export type CompanyFragment = {
  __typename?: "Company";
  company_id?: string | null;
  company_name?: string | null;
  company_sales_rep?: string | null;
};

export type ContactInfoFragment = {
  __typename?: "ContactInfo";
  first_name?: string | null;
  last_name?: string | null;
  name?: string | null;
  email?: string | null;
};

export type TerminalFragment = {
  __typename?: "Terminal";
  terminal_id: string;
  terminal_name?: string | null;
  terminal_alt_name?: string | null;
  terminal_status?: string | null;
  terminal_latitude?: number | null;
  terminal_longitude?: number | null;
  terminal_address?: string | null;
  terminal_physical_modem_location?: string | null;
  terminal_service_plan?: string | null;
  terminal_service_plan_usage_based?: string | null;
  terminal_modem_serial?: string | null;
  terminal_modem_type?: string | null;
  terminal_equip_antenna?: string | null;
  terminal_equip_buc?: string | null;
  terminal_ipaddr_primary?: string | null;
  terminal_ipaddr_nat?: string | null;
  terminal_ipaddr_management?: string | null;
  terminal_notes?: string | null;
  company?: {
    __typename?: "Company";
    company_id?: string | null;
    company_name?: string | null;
    company_sales_rep?: string | null;
  } | null;
  network?: {
    __typename?: "Network";
    network_id?: string | null;
    network_name?: string | null;
    network_manufacturer?: string | null;
    network_model?: string | null;
  } | null;
  usage_summary?: {
    __typename?: "UsageSummary";
    tx_bytes?: any | null;
    rx_bytes?: any | null;
    total_bytes?: any | null;
  } | null;
};

// ! ADD NEW TECHNOLOGY
export type TerminalUsageFragment = {
  __typename?: "TerminalUsage";
  usage?: Array<
    | {
        __typename?: "UsageItemNewtec";
        timestamp_end: Date;
        timestamp_start: Date;
        bytes: any;
        enabled?: boolean | null;
      }
    | {
        __typename?: "UsageItemPGE";
        timestamp_end: Date;
        timestamp_start: Date;
        tx_low?: any | null;
        tx_2?: any | null;
        enabled?: boolean | null;
        rx_2?: any | null;
        rx_3?: any | null;
        rx_5?: any | null;
        rx_6?: any | null;
        rx_high?: any | null;
        rx_low?: any | null;
        rx_med?: any | null;
        rx_total?: any | null;
        tx_3?: any | null;
        tx_5?: any | null;
        tx_6?: any | null;
        tx_high?: any | null;
        tx_med?: any | null;
        tx_total?: any | null;
      }
    | {
        __typename?: "UsageItemUHP";
        timestamp_end: Date;
        timestamp_start: Date;
        enabled?: boolean | null;
        rx_2?: any | null;
        rx_3?: any | null;
        rx_5?: any | null;
        rx_6?: any | null;
        rx_high?: any | null;
        rx_med?: any | null;
        rx_low?: any | null;
        rx_total?: any | null;
        tx_3?: any | null;
        tx_2?: any | null;
        tx_5?: any | null;
        tx_6?: any | null;
        tx_high?: any | null;
        tx_low?: any | null;
        tx_med?: any | null;
        tx_total?: any | null;
        usage_total?: any | null;
      }
    | {
        __typename?: "UsageItemViasat";
        timestamp_end: Date;
        timestamp_start: Date;
        enabled?: boolean | null;
        bytes: any;
      }
    | {
        __typename?: "UsageItemGroundControl";
        timestamp_end: Date;
        timestamp_start: Date;
        enabled?: boolean | null;
        bytes: any;
      }
    | {
        __typename?: "UsageItemKoreWireless";
        timestamp_end: Date;
        timestamp_start: Date;
        enabled?: string | null;
        bytes: any;
      }
    | {
        __typename?: "UsageItemOneWeb";
        timestamp_end: Date;
        timestamp_start: Date;
        enabled?: string | null;
        tx: any;
        rx: any;
      }
    | {
        __typename?: "UsageItemHammer";
        timestamp_end: Date;
        timestamp_start: Date;
        enabled?: string | null;
        tx: any;
        rx: any;
      }
    | {
        __typename?: "UsageItemCuris";
        timestamp_end: Date;
        timestamp_start: Date;
        enabled?: string | null;
        tx: any;
        rx: any;
      }
    | null
  > | null;
  terminal?: {
    __typename?: "Terminal";
    terminal_id: string;
    terminal_name?: string | null;
    terminal_status?: string | null;
    terminal_alt_name?: string | null;
  } | null;
};

export type GetContactQueryVariables = Exact<{ [key: string]: never }>;

export type GetContactQuery = {
  __typename?: "Query";
  getContact?: {
    __typename?: "ContactInfo";
    first_name?: string | null;
    last_name?: string | null;
    name?: string | null;
    email?: string | null;
  } | null;
};

export type GetTerminalUsageQueryVariables = Exact<{
  time_end?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  time_start?: InputMaybe<Scalars["AWSDateTime"]["input"]>;
  terminal_ids?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  frequency?: InputMaybe<Scalars["String"]["input"]>;
}>;

// ! ADD NEW TECHNOLOGY
export type GetTerminalUsageQuery = {
  __typename?: "Query";
  getTerminalUsage?: {
    __typename?: "TermninalUsagePage";
    count?: number | null;
    current_page?: number | null;
    last_page?: number | null;
    per_page?: number | null;
    total?: number | null;
    terminal_usage?: Array<{
      __typename?: "TerminalUsage";
      usage?: Array<
        | {
            __typename?: "UsageItemNewtec";
            timestamp_end: Date;
            timestamp_start: Date;
            bytes: any;
            enabled?: boolean | null;
          }
        | {
            __typename?: "UsageItemPGE";
            timestamp_end: Date;
            timestamp_start: Date;
            tx_low?: any | null;
            tx_2?: any | null;
            enabled?: boolean | null;
            rx_2?: any | null;
            rx_3?: any | null;
            rx_5?: any | null;
            rx_6?: any | null;
            rx_high?: any | null;
            rx_low?: any | null;
            rx_med?: any | null;
            rx_total?: any | null;
            tx_3?: any | null;
            tx_5?: any | null;
            tx_6?: any | null;
            tx_high?: any | null;
            tx_med?: any | null;
            tx_total?: any | null;
          }
        | {
            __typename?: "UsageItemUHP";
            timestamp_end: Date;
            timestamp_start: Date;
            enabled?: boolean | null;
            rx_2?: any | null;
            rx_3?: any | null;
            rx_5?: any | null;
            rx_6?: any | null;
            rx_high?: any | null;
            rx_med?: any | null;
            rx_low?: any | null;
            rx_total?: any | null;
            tx_3?: any | null;
            tx_2?: any | null;
            tx_5?: any | null;
            tx_6?: any | null;
            tx_high?: any | null;
            tx_low?: any | null;
            tx_med?: any | null;
            tx_total?: any | null;
            usage_total?: any | null;
          }
        | {
            __typename?: "UsageItemViasat";
            timestamp_end: Date;
            timestamp_start: Date;
            enabled?: boolean | null;
            bytes: any;
          }
        | {
            __typename?: "UsageItemGroundControl";
            timestamp_end: Date;
            timestamp_start: Date;
            enabled?: boolean | null;
            bytes: any;
          }
        | {
            __typename?: "UsageItemKoreWireless";
            timestamp_end: Date;
            timestamp_start: Date;
            enabled?: string | null;
            bytes: any;
          }
        | {
            __typename?: "UsageItemOneWeb";
            timestamp_end: Date;
            timestamp_start: Date;
            enabled?: string | null;
            tx: any;
            rx: any;
          }
        | {
            __typename?: "UsageItemCuris";
            timestamp_end: Date;
            timestamp_start: Date;
            enabled?: string | null;
            tx: any;
            rx: any;
          }
        | {
            __typename?: "UsageItemHammer";
            timestamp_end: Date;
            timestamp_start: Date;
            enabled?: string | null;
            tx: any;
            rx: any;
          }
        | null
      > | null;
      terminal?: {
        __typename?: "Terminal";
        terminal_id: string;
        terminal_name?: string | null;
        terminal_status?: string | null;
        terminal_alt_name?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetTerminalsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  filter?: InputMaybe<QueryFilter>;
  company_id?: InputMaybe<Scalars["Int"]["input"]>;
  terminal_ids?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >;
  date_start?: InputMaybe<Scalars["AWSDate"]["input"]>;
  date_end?: InputMaybe<Scalars["AWSDate"]["input"]>;
}>;

export type GetTerminalsQuery = {
  __typename?: "Query";
  getTerminals?: {
    __typename?: "TerminalPage";
    per_page?: number | null;
    last_page?: number | null;
    current_page?: number | null;
    count?: number | null;
    total?: number | null;
    date_start?: any | null;
    date_end?: any | null;
    terminals?: Array<{
      __typename?: "Terminal";
      terminal_id: string;
      terminal_name?: string | null;
      terminal_alt_name?: string | null;
      terminal_status?: string | null;
      terminal_latitude?: number | null;
      terminal_longitude?: number | null;
      terminal_address?: string | null;
      terminal_physical_modem_location?: string | null;
      terminal_service_plan?: string | null;
      terminal_service_plan_usage_based?: string | null;
      terminal_modem_serial?: string | null;
      terminal_modem_type?: string | null;
      terminal_equip_antenna?: string | null;
      terminal_equip_buc?: string | null;
      terminal_ipaddr_primary?: string | null;
      terminal_ipaddr_nat?: string | null;
      terminal_ipaddr_management?: string | null;
      terminal_notes?: string | null;
      company?: {
        __typename?: "Company";
        company_id?: string | null;
        company_name?: string | null;
        company_sales_rep?: string | null;
      } | null;
      network?: {
        __typename?: "Network";
        network_id?: string | null;
        network_name?: string | null;
        network_manufacturer?: string | null;
        network_model?: string | null;
      } | null;
      usage_summary?: {
        __typename?: "UsageSummary";
        tx_bytes?: any | null;
        rx_bytes?: any | null;
        total_bytes?: any | null;
      } | null;
    } | null> | null;
  } | null;
};

export const CompanyFragmentDoc = gql`
  fragment Company on Company {
    company_id
    company_name
    company_sales_rep
  }
`;
export const ContactInfoFragmentDoc = gql`
  fragment ContactInfo on ContactInfo {
    first_name
    last_name
    name
    email
  }
`;
export const TerminalFragmentDoc = gql`
  fragment Terminal on Terminal {
    terminal_id
    terminal_name
    terminal_alt_name
    terminal_status
    terminal_latitude
    terminal_longitude
    terminal_address
    terminal_physical_modem_location
    terminal_service_plan
    terminal_service_plan_usage_based
    terminal_modem_serial
    terminal_modem_type
    terminal_equip_antenna
    terminal_equip_buc
    terminal_ipaddr_primary
    terminal_ipaddr_nat
    terminal_ipaddr_management
    terminal_notes
    company {
      company_id
      company_name
      company_sales_rep
    }
    network {
      network_id
      network_name
      network_manufacturer
      network_model
    }
    usage_summary {
      tx_bytes
      rx_bytes
      total_bytes
    }
  }
`;

// ! ADD NEW TECHNOLOGY
export const TerminalUsageFragmentDoc = gql`
  fragment TerminalUsage on TerminalUsage {
    usage {
      ... on UsageItemGroundControl {
        timestamp_end
        timestamp_start
        bytes
        enabled
      }
      ... on UsageItemKoreWireless {
        timestamp_end
        timestamp_start
        bytes
        koreStatus: enabled
      }
      ... on UsageItemOneWeb {
        timestamp_end
        timestamp_start
        tx
        rx
        OneWebStatus: enabled
      }
      ... on UsageItemViasat {
        timestamp_end
        timestamp_start
        enabled
        bytes
      }
      ... on UsageItemUHP {
        timestamp_end
        timestamp_start
        enabled
        rx_2
        rx_3
        rx_5
        rx_6
        rx_high
        rx_med
        rx_low
        rx_total
        tx_3
        tx_2
        tx_5
        tx_6
        tx_high
        tx_low
        tx_med
        tx_total
        usage_total
      }
      ... on UsageItemNewtec {
        timestamp_end
        timestamp_start
        bytes
        enabled
      }
      ... on UsageItemCuris {
        timestamp_end
        timestamp_start
        tx
        rx
        CurisStatus: enabled
      }
      ... on UsageItemHammer {
        timestamp_end
        timestamp_start
        tx
        rx
        HammerStatus: enabled
      }
      ... on UsageItemPGE {
        timestamp_end
        timestamp_start
        tx_low
        tx_2
        enabled
        rx_2
        rx_3
        rx_5
        rx_6
        rx_high
        rx_low
        rx_med
        rx_total
        tx_3
        tx_5
        tx_6
        tx_high
        tx_med
        tx_total
      }
    }
    terminal {
      terminal_id
      terminal_name
      terminal_status
      terminal_alt_name
    }
  }
`;
export const GetContactDocument = gql`
  query getContact {
    getContact {
      first_name
      last_name
      name
      email
    }
  }
`;

/**
 * __useGetContactQuery__
 *
 * To run a query within a React component, call `useGetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetContactQuery,
    GetContactQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContactQuery, GetContactQueryVariables>(
    GetContactDocument,
    options
  );
}
export function useGetContactLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContactQuery,
    GetContactQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContactQuery, GetContactQueryVariables>(
    GetContactDocument,
    options
  );
}
export type GetContactQueryHookResult = ReturnType<typeof useGetContactQuery>;
export type GetContactLazyQueryHookResult = ReturnType<
  typeof useGetContactLazyQuery
>;
export type GetContactQueryResult = Apollo.QueryResult<
  GetContactQuery,
  GetContactQueryVariables
>;
export function refetchGetContactQuery(variables?: GetContactQueryVariables) {
  return { query: GetContactDocument, variables: variables };
}
export const GetTerminalUsageDocument = gql`
  query getTerminalUsage(
    $time_end: AWSDateTime
    $time_start: AWSDateTime
    $terminal_ids: [Int]
    $frequency: String
  ) {
    getTerminalUsage(
      time_end: $time_end
      time_start: $time_start
      terminal_ids: $terminal_ids
      frequency: $frequency
    ) {
      count
      current_page
      last_page
      per_page
      total
      terminal_usage {
        ...TerminalUsage
      }
    }
  }
  ${TerminalUsageFragmentDoc}
`;

/**
 * __useGetTerminalUsageQuery__
 *
 * To run a query within a React component, call `useGetTerminalUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerminalUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTerminalUsageQuery({
 *   variables: {
 *      time_end: // value for 'time_end'
 *      time_start: // value for 'time_start'
 *      terminal_ids: // value for 'terminal_ids'
 *      frequency: // value for 'frequency'
 *   },
 * });
 */
export function useGetTerminalUsageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTerminalUsageQuery,
    GetTerminalUsageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTerminalUsageQuery, GetTerminalUsageQueryVariables>(
    GetTerminalUsageDocument,
    options
  );
}
export function useGetTerminalUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTerminalUsageQuery,
    GetTerminalUsageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTerminalUsageQuery,
    GetTerminalUsageQueryVariables
  >(GetTerminalUsageDocument, options);
}
export type GetTerminalUsageQueryHookResult = ReturnType<
  typeof useGetTerminalUsageQuery
>;
export type GetTerminalUsageLazyQueryHookResult = ReturnType<
  typeof useGetTerminalUsageLazyQuery
>;
export type GetTerminalUsageQueryResult = Apollo.QueryResult<
  GetTerminalUsageQuery,
  GetTerminalUsageQueryVariables
>;
export function refetchGetTerminalUsageQuery(
  variables?: GetTerminalUsageQueryVariables
) {
  return { query: GetTerminalUsageDocument, variables: variables };
}
export const GetTerminalsDocument = gql`
  query getTerminals(
    $limit: Int
    $page: Int
    $filter: QueryFilter
    $company_id: Int
    $terminal_ids: [Int]
    $date_start: AWSDate
    $date_end: AWSDate
  ) {
    getTerminals(
      limit: $limit
      page: $page
      filter: $filter
      company_id: $company_id
      terminal_ids: $terminal_ids
      date_start: $date_start
      date_end: $date_end
    ) {
      per_page
      last_page
      current_page
      count
      total
      date_start
      date_end
      terminals {
        ...Terminal
      }
    }
  }
  ${TerminalFragmentDoc}
`;

/**
 * __useGetTerminalsQuery__
 *
 * To run a query within a React component, call `useGetTerminalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTerminalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTerminalsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      company_id: // value for 'company_id'
 *      terminal_ids: // value for 'terminal_ids'
 *      date_start: // value for 'date_start'
 *      date_end: // value for 'date_end'
 *   },
 * });
 */
export function useGetTerminalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTerminalsQuery,
    GetTerminalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTerminalsQuery, GetTerminalsQueryVariables>(
    GetTerminalsDocument,
    options
  );
}
export function useGetTerminalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTerminalsQuery,
    GetTerminalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTerminalsQuery, GetTerminalsQueryVariables>(
    GetTerminalsDocument,
    options
  );
}
export type GetTerminalsQueryHookResult = ReturnType<
  typeof useGetTerminalsQuery
>;
export type GetTerminalsLazyQueryHookResult = ReturnType<
  typeof useGetTerminalsLazyQuery
>;
export type GetTerminalsQueryResult = Apollo.QueryResult<
  GetTerminalsQuery,
  GetTerminalsQueryVariables
>;
export function refetchGetTerminalsQuery(
  variables?: GetTerminalsQueryVariables
) {
  return { query: GetTerminalsDocument, variables: variables };
}
